import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

export interface Section {
  id: number;
  building: number;
  region: string;
  statement: string;
  active: boolean;
  blocked: boolean;
  department: string[];
  exceptions: string[];
  checkin: boolean;
  statement_start: string;
  statement_end: string;
}

export interface Desk {
  name: string;
  table_id: number;
  id: number | null;
  weekday: number[];
  start_date: string | null;
  end_date: string | null;
  observation: string;
  active: boolean | null;
  username: string;
  responsible: string;
}

export interface SectionConfig {
  id: number;
  blocked: boolean;
  department: string[];
  exceptions: string[];
  checkin: boolean;
}

export interface CommunicationRequest {
  id: number;
  statement: any;
  statement_start: any;
  statement_end: any;
}

@Injectable({
  providedIn: 'root'
})
export class AdminApiService {

  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/Admin`;

  getSections(): Observable<Section[]> {
    return this.http.get<Section[]>(`${this.apiUrl}/sections`);
  }
 
  putBlockDesks(desks: Desk[]): Observable<any> {
    const url = `${this.apiUrl}/blockDesks`;
    console.log('putBlockDesks - URL:', url);
    console.log('putBlockDesks - Desks:', desks);
    console.log('putBlockDesks - Payload:', JSON.stringify(desks, null, 2));
    return this.http.put<any>(url, desks);
  }

  getDesks(deskId: number): Observable<Desk[]> {
    return this.http.get<Desk[]>(`${this.apiUrl}/desks/${deskId}`);
  }
  
  getBlockDesks(): Observable<Desk[]> {
    return this.http.get<Desk[]>(`${this.apiUrl}/blockDesks`);
  }

  deleteDeskBlocks(ids: number[]): Observable<void> {
    return this.http.request<void>('DELETE', `${this.apiUrl}/deleteDeskBlocks`, { body: ids });
  }

  putSectionConfig(config: SectionConfig): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/sectionConfig`, config);
  }

  putCommunication(communicationConfig: CommunicationRequest): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/communication`, communicationConfig);
  }

}